<template>
  <DialogLayout
    title="新規取込"
    :visible.sync="dialogVisible"
    width="55em"
    @open="open"
  >
    <template #form>
      <ImportForm
        ref="importForm"
        v-model="importFormModel"
        action="/import-takeoff-passengers-data"
        label="有償旅客データファイル"
        formMode="transaction"
        extension="csv|txt"
        :actualmode=2
        :dispAllCases="dispAllCases"
        @import-success="importSuccess"
        @import-error="importError"
      />
    </template>
    <template #footer>
      <ImportDialogFooter
        @import="clickImport"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import ImportForm from '@/components/organisms/dialog/ImportForm.vue'
import ImportDialogFooter from '@/components/organisms/dialog/ImportDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    ImportForm,
    ImportDialogFooter
  },
  mixins: [
  ],
  props: {
    visible: Boolean
  },
  data () {
    return {
      importFormModel: {
        billing_ym: undefined,
        data_capture: '2'
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickImport () {
      this.$loadingMask.on()
      this.$refs.importForm.validate()
        .then((res) => {
          this.$refs.importForm.import()
        })
        .catch((e) => {
          console.log(e)
          this.$loadingMask.off()
        })
    },
    importSuccess (res) {
      if (res.status === 202) {
        this.$fcMessage.showMessage({
          id: 'CMN0004I',
          link: {
            fileName: 'error.txt',
            messages: res.data.message
          }
        }, true)
      } else {
        this.$fcMessage.showMessage(res.data.message)
      }
      this.dialogVisible = false
      this.$emit('refresh', this.importFormModel.billing_ym)
    },
    importError (res) {
      this.$fcMessage.showMessage({
        id: 'CMN0033E',
        link: {
          fileName: 'error.txt',
          messages: res.data.message
        }
      }, true)
      this.$loadingMask.off()
    },
    open () {
      this.$nextTick(function () {
        this.$refs.importForm.clear()
      })
    },
    dispAllCases () {
      if (this.$loginuser.get('role_id').indexOf('airline') === -1) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss">
    // 実績年月の表示追加
    .el-form-item{
    white-space: nowrap;
  }
</style>
